import { useCallback, useRef, useState } from 'react';
const usePopoverState = () => {
    const anchorRef = useRef(null);
    const [open, setIsOpen] = useState(false);
    const handleOpen = useCallback(() => {
        setIsOpen(true);
    }, []);
    const handleClose = useCallback(() => {
        setIsOpen(false);
    }, []);
    return [anchorRef, open, handleOpen, handleClose];
};
export default usePopoverState;
